import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {ENTER} from "@angular/cdk/keycodes";
import {FormBuilder, FormControl} from "@angular/forms";
import {HttpClient} from "@angular/common/http";
import {UsefulFunctionsService} from "../useful-functions.service";
import {ChipsListComponent} from "../chips-list/chips-list.component";
import {MatChipInputEvent} from "@angular/material/chips";
import {MatAutocompleteSelectedEvent} from "@angular/material/autocomplete";
import {environment} from "../../environments/environment";

//TODO create as a global interface?
interface chipElement {
  arrayString: string[];
  formArrayName: string;
}


@Component({
  selector: 'app-recommendations',
  templateUrl: './recommendations.component.html',
  styleUrls: ['./recommendations.component.scss']
})
export class RecommendationsComponent implements OnInit {

  getRecommendationsForm = this.fb.group({
    EAN: [''],
    personalList: this.fb.array([]),
  });

  results: any //The JSON object that will contain the results from the request

  //Chips boolean, TODO move into the chip list component
  visible = true;
  selectable = true;
  removable = true;
  separatorKeysCodes: number[] = [ENTER];

  personalListCtrl = new FormControl(); //FormControl for the EAN input
  @ViewChild('personalListInput') personalListInput: ElementRef<HTMLInputElement>;
  personalListChipElement: chipElement= {
    arrayString: [],
    formArrayName: 'personalList',
  }

  inputElements = [] //Array that will gather the different input defined as ElementRef

  //Extension Panel steps
  step = 0;
  personalListSelected: boolean = false // Boolean marking if the step has been done or not

  setStep(index: number) {
    this.step = index;
  }

  nextStep() {
    this.step++;
  }

  prevStep() {
    this.step--;
  }

  constructor(private fb: FormBuilder,
              public httpClient: HttpClient,
              public usefulFunctionsService: UsefulFunctionsService,
              public chipListComponent: ChipsListComponent) {

    this.personalListCtrl.valueChanges.subscribe(async (inci: any) => {
      this.usefulFunctionsService.possibleINCIs = await this.usefulFunctionsService.searchIngredients(inci)
    })
  }

  ngOnInit(): void {
    this.getRecommendationsForm.value.EAN = 11093770 //Define an initial value for testing purposes
    //Test results
    /*this.results = [
      {
        "EAN": "3770003788218",
        "image": "https://s3-eu-west-1.amazonaws.com/cosmethics.fi/ean_images/3770003788218.jpg",
        "name": "100% Pur Beurre de Karite",
        "brand": "La Savonnerie Champagne",
        "size": "",
        "INCI": [
          "BUTYROSPERMUM PARKII BUTTER"
        ],
        "sub_category": "Body lotion/Balm/Cream/Gel",
        "product_update_time": "2017-11-26T21:20:37.431Z",
        "date_submitted": "2016-10-08T18:33:27.453Z",
        "image_link": "https://s3-eu-west-1.amazonaws.com/cosmethics-user-uploads/b42eedc0-8d85-11e6-b4ae-3b3379a80441_front.jpg",
        "image_ingredients_link": "https://s3-eu-west-1.amazonaws.com/cosmethics-user-uploads/b42eedc0-8d85-11e6-b4ae-3b3379a80441_ingredients.jpg",
        "country": "France",
        "haveVersions": false,
        "category_name": "Bath and Body Products",
        "alerts": {
          "Petrochemicals": [],
          "Irritating Alcohols": [],
          "Endocrine Disruptors": [],
          "Palm Oil": [],
          "Silicones": [],
          "Perfluorinated, polyfluorinated and related substances": [],
          "Chemical sensitisers  (preservatives)": [],
          "Conscious Consumer": [],
          "Vegan": [],
          "Aluminum": [],
          "European Chemicals Agency - High Concern List": [],
          "Plastics": [],
          "Fragrance Allergens": [],
          "Chemical sensitisers  (colorants)": [],
          "Aluminum in deodorant": [],
          "UV-Filter Concern List": [],
          "Nail Products Concern List": [],
          "Fluorides in Oral Hygiene": [],
          "Formaldehyde": [],
          "Phthalates": [],
          "Parabens": [],
          "Triclosan": [],
          "Isothiazolinone": [],
          "List of Substances Prohibited in Cosmetic Products in European Union": [],
          "CMR Substances": [],
          "personal list": []
        }
      },
      {
        "image": "https://s3-eu-west-1.amazonaws.com/cosmethics.fi/ean_images/3350900000400_0.jpg",
        "name": "Baume Secours",
        "brand": "Embryolisse",
        "size": "15 ml",
        "EAN": "3350900000400",
        "INCI": [
          "BUTYROSPERMUM PARKII BUTTER",
          "PRUNUS AMYGDALUS DULCIS OIL",
          "GOSSYPIUM HERBACEUM SEED OIL",
          "HYDROGENATED SWEET ALMOND OIL",
          "PRUNUS ARMENIACA KERNEL OIL",
          "HYDROGENATED COTTONSEED OIL",
          "HYDROGENATED APRICOT KERNEL OIL",
          "PARFUM",
          "TOCOPHEROL"
        ],
        "sub_category": "Body lotion/Balm/Cream/Gel",
        "date_submitted": "2017-06-09T11:40:53.310Z",
        "image_link": "https://s3-eu-west-1.amazonaws.com/cosmethics-user-uploads/7e5b9de0-4d08-11e7-b2ea-a90436953a57_front.jpg",
        "image_ingredients_link": "https://s3-eu-west-1.amazonaws.com/cosmethics-user-uploads/7e5b9de0-4d08-11e7-b2ea-a90436953a57_ingredients.jpg",
        "country": "France",
        "haveVersions": false,
        "category_name": "Bath and Body Products",
        "alerts": {
          "Petrochemicals": [],
          "Irritating Alcohols": [],
          "Endocrine Disruptors": [],
          "Palm Oil": [],
          "Silicones": [],
          "Perfluorinated, polyfluorinated and related substances": [],
          "Chemical sensitisers  (preservatives)": [],
          "Conscious Consumer": [],
          "Vegan": [],
          "Aluminum": [],
          "European Chemicals Agency - High Concern List": [],
          "Plastics": [],
          "Fragrance Allergens": [],
          "Chemical sensitisers  (colorants)": [],
          "Aluminum in deodorant": [],
          "UV-Filter Concern List": [],
          "Nail Products Concern List": [],
          "Fluorides in Oral Hygiene": [],
          "Formaldehyde": [],
          "Phthalates": [],
          "Parabens": [],
          "Triclosan": [],
          "Isothiazolinone": [],
          "List of Substances Prohibited in Cosmetic Products in European Union": [],
          "CMR Substances": [],
          "personal list": []
        }
      },
      {
        "image": "https://s3-eu-west-1.amazonaws.com/cosmethics.fi/ean_images/5901878681238_0.jpg",
        "name": "Olej Kokosowy Nierafinowany",
        "brand": "Tacomi",
        "size": "",
        "EAN": "5901878681238",
        "INCI": [
          "COCOS NUCIFERA OIL"
        ],
        "sub_category": "Body lotion/Balm/Cream/Gel",
        "date_submitted": "2017-01-15T15:17:14.672Z",
        "image_link": "https://s3-eu-west-1.amazonaws.com/cosmethics-user-uploads/b1f48300-db35-11e6-9ff0-51f225d34381_front.jpg",
        "image_ingredients_link": "https://s3-eu-west-1.amazonaws.com/cosmethics-user-uploads/b1f48300-db35-11e6-9ff0-51f225d34381_ingredients.jpg",
        "country": "Poland",
        "haveVersions": false,
        "category_name": "Bath and Body Products",
        "alerts": {
          "Petrochemicals": [],
          "Irritating Alcohols": [],
          "Endocrine Disruptors": [],
          "Palm Oil": [],
          "Silicones": [],
          "Perfluorinated, polyfluorinated and related substances": [],
          "Chemical sensitisers  (preservatives)": [],
          "Conscious Consumer": [],
          "Vegan": [],
          "Aluminum": [],
          "European Chemicals Agency - High Concern List": [],
          "Plastics": [],
          "Fragrance Allergens": [],
          "Chemical sensitisers  (colorants)": [],
          "Aluminum in deodorant": [],
          "UV-Filter Concern List": [],
          "Nail Products Concern List": [],
          "Fluorides in Oral Hygiene": [],
          "Formaldehyde": [],
          "Phthalates": [],
          "Parabens": [],
          "Triclosan": [],
          "Isothiazolinone": [],
          "List of Substances Prohibited in Cosmetic Products in European Union": [],
          "CMR Substances": [],
          "personal list": ["AQUA"]
        }
      }]*/
  }

  /**
   * Manage the add event from a MapChipInput
   * @param event,MatChipInputEvent, the event of adding a chip
   * @param formControl, the formControl linked to the input
   * @param array, the array from the component.ts
   * @param formArrayName, the name of the formArray in the form
   * @param inci, boolean indicating whether we are dealing with an INCI input or not
   * @source: https://material.angular.io/components/chips/api
   */
  add(event: MatChipInputEvent, formControl, array, formArrayName, inci:boolean): void {
    const input = event.input;
    const value = event.value;

    if (formArrayName == 'personalList') this.personalListSelected = true

    this.chipListComponent.addChip(value, null, array, formArrayName, formControl, this.getRecommendationsForm, inci)

    // Reset the input value
    if (input) {
      input.value = '';
    }
  }

  /**
   * Manage the add event from a MatAutocompleteSelectedEvent, by adding a chip and the value into the formControl
   * @param event, MatAutocompleteSelectedEvent, the selection event
   * @param formControl, the formControl linked to the input
   * @param array, the array from the component.ts
   * @param formArrayName, the name of the formArray in the form
   * @param inci, boolean indicating whether we are dealing with an INCI input or not
   * @source: https://material.angular.io/components/chips/api
   */
  selected(event: MatAutocompleteSelectedEvent, formControl, array, formArrayName, inci:boolean): void {

    this.inputElements = [this.personalListInput] //Pass all the inputs that can be selected in the array

    const value = inci ? event.option.viewValue: event.option.value;
    const viewValue = event.option.viewValue;

    if (formArrayName == 'personalList') this.personalListSelected = true

    //Clean all the inputs value as we cannot select the current input as native element
    this.inputElements.forEach(nativeElement => {
      nativeElement.nativeElement.value = ''
    })

    this.chipListComponent.addChip(value, viewValue, array, formArrayName, formControl, this.getRecommendationsForm, inci)
  }

  /**
   * Manage the form submission
   */
  async onSubmit() {

    this.getRecommendationsForm.value.EAN = this.getRecommendationsForm.value.EAN.toString()
    this.results = null

    var tokenData: any = await this.httpClient.post(environment.apiUrl+"temptoken", {"id":sessionStorage.getItem('id')}).toPromise()

    var bodyPredefinedForTest = {
      "EAN":"11093770",
      "personalList": ["AQUA"]
    }

    //ToPromise convert an Observable to a Promise (more info here: https://blog.fullstacktraining.com/angular-promise-vs-observable/)
    var data = await this.httpClient.post(environment.apiUrl+"getRecommendations",
      //bodyPredefinedForTest,
      this.getRecommendationsForm.value,
      {"headers": {
          "Authorization": "Bearer " + tokenData.token,
          "Content-Type": "application/json"
        }}).toPromise()


    //Format the alerts object in order to display if alerts are popped, see if we want the image
    data['data'] = data['data'].map(product => {
      product.alertsDisplay = []
      for (const [key, value] of Object.entries(product.alerts)) {
        console.log(`${key}: ${value}`);
        product.alertsDisplay.push({name:key,INCI:value})
      }
      return product
    })


    this.results = data['data']
  }

  /**
   * Check if some alerts are prompt in a product
   * @param array, the array of object were we check if some have their boolean checked at true
   */
  someAlerts(product: any): boolean {
    return product.alertsDisplay.some(alert => alert.INCI.length > 0)
  }
}
